const SidebarData = [
  {
    label: "Main Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },

  {
    label: "Pokémon",
    icon: "mdi mdi-pokeball",
    subItem: [
          { sublabel: "Roster", link: "/roster" }, 
      { sublabel: "Your Pokémon", link: "/box" },   
      { sublabel: "Pokédex", link: "/pokedex" },
    ],
  },
  {
    label: "Messages",
    icon: "mdi mdi-email-outline",
    url: "/inbox",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
  },
  {
    label: "Manage Trades",
    icon: "mdi mdi-offer",
    url: "/manage-trades",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
  },
  {
    label: "Manage Battles",
    icon: "mdi mdi-sword-cross",
    url: "/manage-battles",
    isHasArrow: true,
    bgcolor: "bg-danger",
  },
  {
    label: "Manage Items",
    icon: "mdi mdi-archive",
    isHasArrow: true,
    url: "/manage-items",
  },
  {
    label: "Skill Tree",
    icon: "ri-git-branch-line",
    url: "/skill-tree",
    isHasArrow: true,
  }, {
    label: "Weekly Missions",
    icon: "mdi mdi-script-text-outline",
    url: "/weekly-missions",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Notifications",
    icon: "mdi mdi-bell",

    
    url: "/notifications",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3",
  },
  
  {
    label: "Maps & Towers",
    isMainMenu: true,
  },
  {
    label: "Battle Tower",
    icon: "ri-ancient-gate-line",
    url: "/map/BattleTowerEntrance",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Radiant Isles",
    icon: "mdi mdi-island",
    url: "/map/Island",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Maps",
    icon: "ri-map-pin-line",
    subItem: [
      { sublabel: "Safari Zone", link: "/map/SafariZone" },
      { sublabel: "Pokémon Pond", link: "/map/PokemonPond" },
      //{ sublabel: "Ruin Valley", link: "/map/RuinValley" },
      { sublabel: "Ruin Valley", link: "/map/RuinValley" },
      { sublabel: "Low Visibility", link: "/map/LowVisibility" },
    ],

  },
{
  label: "Mini Maps",
  icon: "ri-map-pin-add-line",
  subItem: [
    { sublabel: "Ember Spa", link: "/map/EmberSpa" },
    { sublabel: "Treasure Beach", link: "/map/TreasureBeach" },
    { sublabel: "Snowveil Outpost", link: "/map/SnowveilOutpost" },
    { sublabel: "Rusturf Tunnel", link: "/map/RusturfTunnel" },
   // { sublabel: "Route25", link: "/map/Route25" },
  ],
},
 /*{
  label: "Community Maps",
  icon: "ri-team-line",
  subItem: [
   { sublabel: "Low Visibility", link: "/map/CommunityLowVisibility" },
  ],
}, */
  {
    label: " Shop & Games",
    isMainMenu: true,
  },
  {
    label: "Market",
    icon: "mdi mdi mdi-store",
    subItem: [
      { sublabel: "Promo Center", link: "/promo-center" },
      { sublabel: "Player Shop", link: "/playershop" },
      { sublabel: "Department Store", link: "/department-store" },
      { sublabel: "Sabrina's Bulk Bazaary", link: "/sabrina-buy" },
    ],
  },
  {
    label: "Games Corner",
    icon: "ri-gamepad-line",
    url: "/games-corner",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Rankings",
    isMainMenu: true,
  },
  {
    label: "Leaderboard",
    icon: "mdi mdi-trophy-award",
    subItem: [
      { sublabel: "Trainer Rankings", link: "/trainer-rankings" },
      { sublabel: "Pokemon Rankings", link: "/pokemon-rankings" },
      { sublabel: "Catcher Rankings", link: "/catch-rankings" },
      { sublabel: "Miner Rankings", link: "/miner-rankings" },
      { sublabel: "Map Rankings", link: "/map-rankings" },
      { sublabel: "Coin Rankings", link: "/coins-rankings" },
      { sublabel: "Money Rankings", link: "/money-rankings" },
    ],
  }, 
  {
    label: "Misc",
    isMainMenu: true,
  },
  {
    label: "Box Rater",
    icon: "mdi mdi-chart-line",
    url: "/box-rater",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Rate List",
    icon: "mdi mdi-cash-multiple",
    url: "/rate-list",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Referral Shop",
    icon: "mdi mdi-gift-outline",
    url: "/referral-system",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Staff List",
    icon: "mdi mdi-account-group",
    url: "/staff-list",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
];
export default SidebarData;
